"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _underscore = require("underscore");

var _immutable = _interopRequireDefault(require("immutable"));

var _GoodsActions = require("../actions/GoodsActions");

var _utils = require("../utils/utils");

var _UIRouterLink = _interopRequireDefault(require("ui-addon-react-router/UIRouterLink"));

var FilterRouterLink =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FilterRouterLink, _PureComponent);

  function FilterRouterLink() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, FilterRouterLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(FilterRouterLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.trackGoodInfoClick = function () {
      var _this$props = _this.props,
          filters = _this$props.filters,
          trackGoodInfoClick = _this$props.trackGoodInfoClick;
      var trackingData = (0, _utils.getQueryParams)(filters);
      trackGoodInfoClick(trackingData);
    };

    return _this;
  }

  (0, _createClass2.default)(FilterRouterLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          filters = _this$props2.filters,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["filters"]);
      return _react.default.createElement(_UIRouterLink.default, (0, _extends2.default)({}, (0, _underscore.omit)(rest, 'trackGoodInfoClick'), {
        onClick: this.trackGoodInfoClick,
        to: (0, _utils.getUrlWithNonInitialFiltersAndPageShown)(filters)
      }));
    }
  }]);
  return FilterRouterLink;
}(_react.PureComponent);

FilterRouterLink.propTypes = {
  filters: _propTypes.default.instanceOf(_immutable.default.Map).isRequired,
  trackGoodInfoClick: _propTypes.default.func.isRequired
};
var mapDispatchToProps = {
  trackGoodInfoClick: _GoodsActions.trackGoodInfo
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(FilterRouterLink);

exports.default = _default;
module.exports = exports.default;